<div *ngIf="responses" class="results-area">
    <div class="result" *ngFor="let responseParagraphs of responses; index as i" [ngClass]="resultClass[i]">
        <div class="result-text">
            <p *ngFor="let paragraph of responseParagraphs">{{paragraph}}</p>
        </div>
        <span class="result-button-wrapper">
            <button mat-icon-button color="warn" (click)="onReject(i)"
                [disabled]="requestRunning"><mat-icon>close</mat-icon></button>
            <button mat-icon-button color="primary" (click)="onAccept(i)"
                [disabled]="requestRunning"><mat-icon>done</mat-icon></button>
        </span>
    </div>
</div>